import {
  Box,
  Flex,
  Text,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  IconButton,
} from "@chakra-ui/react";
import React, { useState, useEffect } from "react";
import Avatar from "../../assets/images/avatar.png";
import { unwrapResult } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";
import { menu } from "../../Constant";
import {
  Button,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
} from "@chakra-ui/react";
import {
  ChevronDownIcon,
  ChevronUpIcon,
  HamburgerIcon,
} from "@chakra-ui/icons";
import { SignOut, getUserDetails } from "../../redux/auth/AuthSlice.js";
import jwt_decode from "jwt-decode";
import { rcExpiryStatus } from "../../api.js";

function Topbar({ toggleSidebar, isMobile, isSidebarOpen }) {
  const { user } = useSelector((state) => state.auth);
  const { userData } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [dropdownIsOpen, setDropdownIsOpen] = useState(false);
  const [rcExpiryDetails, setRcExpiryDetails] = useState({});

  const decodedUser = jwt_decode(user);
  const userId = decodedUser?._id;

  const handleDropdownToggle = () => {
    setDropdownIsOpen((prev) => !prev);
  };

  const [showMenu, setShowMenu] = useState(false);

  const handleMenuClick = () => {
    setShowMenu(!showMenu);
  };

  const handleSignOut = () => {
    dispatch(SignOut());
  };

  const getUserData = () => {
    try {
      const result = dispatch(getUserDetails(userId));
      unwrapResult(result);
    } catch (error) {
      unwrapResult(error);
    }
  };

  const fetchRcStatus = async () => {
    const response = await rcExpiryStatus(userData?.companyId);
    setRcExpiryDetails(response?.data);
  };

  useEffect(() => {
    getUserData();
  }, []);

  useEffect(() => {
    if (user && userData?.companyId) {
      fetchRcStatus();
    }
  }, [userData?.companyId]);

  return (
    <Box
      position="sticky"
      top="0"
      zIndex={9}
      bg="#EDF3F8"
      width="100%"
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      gap="1rem"
      py="1.5rem"
      pr={{ base: "1rem", md: "1.5rem", lg: "2rem" }}
      pl={{
        base: "1rem",
        md: isSidebarOpen ? "270px" : "120px",
      }}
    >
      {isMobile && (
        <IconButton
          aria-label="Open menu"
          icon={<HamburgerIcon />}
          onClick={toggleSidebar}
          variant="outline"
          bg="white"
        />
      )}
      {!isMobile && <Box />}
      <Flex gap="1rem" alignItems="center" wrap="wrap" justifyContent="flex-end">
        {userData?.role?.includes("CLIENT") &&
          rcExpiryDetails?.status === "EXPIRED" && (
            <Alert status="error" borderRadius={"10px"}>
              <AlertIcon />
              <AlertTitle>Your RC has been expired.</AlertTitle>
              <AlertDescription>
                Please renew your RC first before performing any action.
              </AlertDescription>
            </Alert>
          )}

        <Box>
          <Box
            display="inline-block"
            position="relative"
            cursor="pointer"
            onClick={handleMenuClick}
          >
            <Button
              rightIcon={showMenu ? <ChevronUpIcon /> : <ChevronDownIcon />}
            >
              {userData?.name}
            </Button>
            {showMenu && (
              <Button
                position="absolute"
                top="100%"
                w={"145px"}
                right="0"
                mt="0.5rem"
                _hover={{ backgroundColor: "red" }}
                backgroundColor="red"
                color={"white"}
                padding="0.5rem"
                zIndex={9}
                onClick={handleSignOut}
              >
                Sign Out
              </Button>
            )}
          </Box>
        </Box>
      </Flex>
    </Box>
  );
}

export default Topbar;
